import { render, staticRenderFns } from "./PersonDocuments.vue?vue&type=template&id=6e82131d"
import script from "./PersonDocuments.vue?vue&type=script&lang=js"
export * from "./PersonDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports